module.exports = __webpack_public_path__ + "img/tallas.33d37163.svg";